import { Children, isValidElement, useMemo } from 'react';

const useMasonry = (children, columns, customDistribution = null) => {
    const columnsChildren = useMemo(() => {
        const group = Array.from({ length: columns }, () => []);

        Children.forEach(children, (child, index) => {
            if (isValidElement(child)) {
                if (customDistribution && customDistribution[index] !== undefined) {
                    // Use custom distribution if provided
                    const targetColumn = customDistribution[index];
                    if (targetColumn >= 0 && targetColumn < columns) {
                        group[targetColumn].push(child);
                    }
                } else {
                    // Fall back to round-robin distribution
                    group[index % columns].push(child);
                }
            }
        });

        return group;
    }, [children, columns, customDistribution]);

    return columnsChildren;
};

export default useMasonry;
